<script>

    import {onMount} from "svelte";

    export let config;
    export let cid;
    export let answerToComment;
    export let reloadComments;

    let comment = {
        author: "",
        content: "",
        official: 0,
        published: 1,
    }

    let status = {
        feedback: false,
        type: "",
        msg: ""
    }

    function submitComment() {
        status.type = "LOADING";
        let answer_to = answerToComment.id;
        if (answer_to === null) {
            answer_to = -1;
        }
        const data = new FormData();
        data.append("content_id", cid);
        data.append("author", comment.author);
        data.append("content", comment.content);
        data.append("answer_to", answer_to);
        data.append("official", comment.official);
        data.append("published", comment.published);

        return new Promise(() => {
            fetch(config.model_root + 'shared/contents/comments/submit_comment.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(msg => {
                    if (msg === "success") {
                        status.feedback = true;
                        status.type = "SUCCESS";
                        status.msg = "Vielen Dank für Ihren Kommentar!"
                        reloadComments();
                        cancelAnswering(); // reset the answer-to mode
                        clearInputs();
                    } else {
                        status.feedback = true;
                        status.type = "ERROR";
                        status.msg = msg;
                    }
                });
        });

    }

    const clearInputs = () => {
        comment.author = "";
        comment.content = "";
    }

    const cancelAnswering = () => {
        answerToComment.id = null;
        answerToComment.preview = "";
    }

</script>

<div class="bg-light p-3 rounded mb-4 shadow">
    <h5><i class="far fa-comment me-1"></i> Verfassen Sie jetzt einen Kommentar.</h5>
    {#if answerToComment.id !== null}
        <div class="border-top border-bottom py-2 my-3">
            <p class="mb-1">Sie antworten auf einen Kommentar:</p>
            <p class="mb-1"><i>"{answerToComment.preview}"</i></p>
            <button class="btn btn-sm btn-secondary" on:click={cancelAnswering}><i class="fas fa-ban"></i> Abbrechen
            </button>
        </div>
    {/if}
    <div class="mt-3">
        <div class="form-group mt-3">
            <label class="form-label">Name</label>
            <input class="form-control form-darkgreen" bind:value={comment.author} placeholder="Name">
        </div>
        <div class="form-group mt-3">
            <label class="form-label">Kommentar</label>
            <textarea maxlength="1000" class="form-control form-darkgreen" rows="4" bind:value={comment.content}
                      placeholder="Kommentar"></textarea>
        </div>
        {#if status.feedback}
            {#if status.type === "ERROR"}
                <div class="alert alert-green-error mt-3">
                    <i class="fas fa-exclamation-circle me-1"></i> {status.msg}
                </div>
            {/if}
            {#if status.type === "SUCCESS"}
                <div class="alert alert-green-success mt-3">
                    <i class="fas fa-check-circle me-1"></i> {status.msg}
                </div>
            {/if}
        {/if}
        <div class="form-group mt-4">
            <button class="btn btn-dark-green px-3 py-2" on:click={submitComment}>
                {#if status.type === "LOADING"}
                    <i class="fas fa-spinner fa-spin me-1"></i>
                {:else}
                    <i class="far fa-paper-plane me-1"></i>
                {/if}
                Kommentar veröffentlichen
            </button>
        </div>

    </div>
</div>

<style>
    h5 {
        font-weight: lighter;
        font-style: italic;
        color: #406343;
    }
</style>
